<template>
  <div class="chart-activity-container" style="background: red">
    <v-chart :options="option" :autoresize="true" id="line-chart"></v-chart>
  </div>
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/line";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "sdcs",
  props: ["timePeriod"],
  data() {
    return {
      totalBooked: 0,
      totalTime: 0,
      option: {},
      months: [
        "",
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
      ]
    };
  },
  computed: {
    ...mapGetters(["getSkillgameLogs", "getBookingsOverview"])
  },
  components: {
    "v-chart": ECharts
  },
  watch: {
    timePeriod: function() {
      this.drawGraph();
    },
    getBookingsOverview() {
      this.drawGraph();
    }
  },
  methods: {
    setXAxisData() {
      return Object.entries(this.getBookingsOverview?.booking_data).map(x => {
        let tempBookings = [];
        if (x[0].length < 5) {
          if (x[0].length == 2) {
            tempBookings.push(this.months[parseInt(x[0])]);
          } else {
            tempBookings.push(x[0]);
          }
        } else {
          tempBookings.push(moment(x[0]).date());
        }

        return tempBookings;
      });
    },
    drawGraph() {
      this.option = {
        color: ["#5696fc", "#7faffc", "#b9d4ff", "#eaf2ff"],
        calculable: true,
        backgroundColor: "#383838",
        grid: {
          show: false,
          left: "3%",
          right: "3%",
          top: "3%",
          bottom: "3%",
          width: "95%",
          height: "95%",
          containLabel: true
        },

        xAxis: {
          show: true,
          type: "category",
          boundaryGap: false,
          data: this.setXAxisData(),
          min: 0,
          axisTick: {
            show: false
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "#aaa",
              type: "dashed",
              width: 1,
              shadowBlur: 3
            }
          },
          axisLabel: {
            show: true,
            interval: 0,
            color: "#aaaaaa",
            margin: 12
          }
        },
        yAxis: {
          type: "value",
          label: { show: true },
          position: "right",
          offset: 10,
          boundaryGap: true,
          min: 0,
          splitNumber: 6,

          minInterval: 1, //to make sure axis label is show as integer.
          maxInterval: 3600 * 1000 * 24, //gap between axis labels is less than or equal to one day.

          axisLine: { show: false },
          axisTick: { show: false },

          splitLine: {
            show: true,
            lineStyle: {
              color: "#747474",
              type: "dashed",
              width: 1
            }
          },
          axisLabel: {
            show: true,
            margin: 5,
            color: "#aaa"
          }
        },
        series: [
          {
            name: "AA",
            type: "line",

            lineStyle: {
              color: "#1ef77a",
              Width: "3px"
            },
            areaStyle: {
              opacity: "1",
              color: new ECharts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 0, color: "#383838" },
                { offset: 1, color: "#365D47" }
              ])
            },

            symbol: "circle",
            symbolSize: 7,
            symbolColor: "red",
            itemStyle: {
              borderWidth: 2,
              borderColor: "#1ef77a",
              color: "white"
            },
            data: Object.entries(this.getBookingsOverview?.booking_data).map(
              x => x[1]
            )
          },
          {
            name: "BB",
            type: "line",
            lineStyle: {
              color: "#f7941e",
              Width: "3px"
            },
            areaStyle: {
              opacity: "1",
              color: new ECharts.graphic.LinearGradient(0, 1, 0, 0, [
                { offset: 0, color: "#383838" },
                { offset: 1, color: "#614C32" }
              ])
            },

            symbol: "circle",
            symbolSize: 7,
            symbolColor: "red",
            itemStyle: {
              borderWidth: 2,
              borderColor: "#f7941e",
              color: "white"
            },

            // data: [10, 10, 40, 30, 50, 10, 20]
            data: this.drawLastTimePeriod
          }
        ]
      };
    }
  },
  mounted() {
    this.drawGraph();
  }
};
</script>

<style>
.chart-activity-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

#line-chart {
  display: flex;
  height: 100%;
  width: 100%;
}

#line-chart > div {
  display: flex;
  width: inherit;
}
</style>
